import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { PAIN_POINTS } from '../data/content';
export function PainPoints() {
  return <section className="px-5 py-8" data-id="element-133">
      <h2 className="text-center font-display text-2xl font-800 uppercase leading-tight text-white" data-id="element-134">
        If you are a pickleball coach or just getting started, this probably
        sounds familiar:
      </h2>

      <ul className="mx-auto mt-6 max-w-xl space-y-3" data-id="element-135">
        {PAIN_POINTS.map(p => <li key={p} className="flex items-start gap-3 rounded-2xl border border-white/20 bg-[#101b2d]/95 p-4 shadow-lg shadow-black/20" data-id="element-136">
            <span className="mt-0.5 shrink-0 text-red-300" data-id="element-137">
              <AlertTriangleIcon size={20} data-id="element-138" />
            </span>
            <span className="text-sm leading-relaxed text-white/95" data-id="element-139">{p}</span>
          </li>)}
      </ul>

      <p className="mx-auto mt-8 max-w-xl rounded-2xl border border-[var(--pb-lime)]/35 bg-[#132033]/95 p-5 text-center font-display text-xl font-800 uppercase leading-tight text-[var(--pb-lime)] shadow-xl shadow-black/20" data-id="element-140">
        That is exactly why Pickleball Coach 360 was created
      </p>
    </section>;
}